import React from 'react';
import { connect } from 'react-redux';
import injectSaga from 'utils/injectSaga';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import saga from '../sagas';

class Data extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  
  render() {
    return (
      <div>
        {React.Children.only(this.props.children)}
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({});
const withConnect = connect(mapStateToProps);
const withSaga = injectSaga({ key: 'tealium', saga });

export default compose(
  withSaga,
  withConnect,
)(Data);

